// Dekripsi file .moto → BIN.
// Struktur (terbukti dari pasangan known-plaintext NMAX B6H; hasil dekripsi identik byte-per-byte
// dengan .bin aslinya): [16 B IV][AES-256-CBC( hex-ASCII dari BIN ) + padding PKCS7].
// Ukuran file selalu = 2 × ukuran BIN + 32.
const MOTO_KEY = "f8Jr2XsNc4YpL6v0MwQaT9zBh1KdR3eE";

export const isMotoFile = (name) => /\.moto$/i.test(name || "");

// Enkripsi BIN → .moto. Kebalikan dari decryptMoto: [16 B IV acak][AES-256-CBC( hex-ASCII lowercase
// dari BIN ) + padding PKCS7]. Terbukti identik byte-per-byte dengan file .moto asli (IV sama).
export async function encryptMoto(binBytes) {
  const bin = new Uint8Array(binBytes);
  let hex = "";
  for (let i = 0; i < bin.length; i++) hex += bin[i].toString(16).padStart(2, "0");
  const iv = crypto.getRandomValues(new Uint8Array(16));
  const key = await crypto.subtle.importKey("raw", new TextEncoder().encode(MOTO_KEY), { name: "AES-CBC" }, false, ["encrypt"]);
  const body = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-CBC", iv }, key, new TextEncoder().encode(hex)));
  const out = new Uint8Array(iv.length + body.length);
  out.set(iv, 0);
  out.set(body, iv.length);
  return out;
}

export async function decryptMoto(buffer) {
  const data = new Uint8Array(buffer);
  if (data.length <= 32 || (data.length - 32) % 32 !== 0)
    throw new Error("ukuran file .moto tidak sesuai format (harus 2×BIN+32)");
  const iv = data.slice(0, 16);
  const body = data.slice(16);
  const key = await crypto.subtle.importKey("raw", new TextEncoder().encode(MOTO_KEY), { name: "AES-CBC" }, false, ["decrypt"]);
  let plain;
  try {
    plain = new Uint8Array(await crypto.subtle.decrypt({ name: "AES-CBC", iv }, key, body));
  } catch {
    throw new Error("gagal dekripsi — file .moto rusak atau dibuat dengan kunci lain");
  }
  const hex = new TextDecoder().decode(plain).trim();
  if (!/^[0-9a-fA-F]+$/.test(hex) || hex.length % 2) throw new Error("isi .moto bukan data BIN yang sah");
  const out = new Uint8Array(hex.length / 2);
  for (let i = 0; i < out.length; i++) out[i] = parseInt(hex.substr(i * 2, 2), 16);
  return out;
}
